import moment from "moment";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Spinner, Row, Col } from "reactstrap";
import { getBlogs, getSignleBlogs } from "../redux/actions/blogs.action";
import { Link } from "react-router-dom";
function BlogDetails(props) {
  const { blog, blogs } = useSelector((state) => state.blogs);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSignleBlogs(props.match.params.id));
    if (blogs.length == 0) {
      dispatch(getBlogs());
    }
  }, []);

  return (
    <>
      {blog ? (
        <Container className="mt-5">
          <div
            style={{ width: "100%", maxWidth: "580px" }}
            className="text-center mx-auto"
          >
            <h1
              className="text-uppercase text-left section-title"
              style={{
                fontFamily: "Ogg",
                letterSpacing: 6,
                wordSpacing: 8,
              }}
            >
              {blog.title}
            </h1>
            <div className="text-left mt-0">
              <small className="text-muted">
                {blog.created_at &&
                  moment.unix(blog.created_at.seconds).format("DD MMMM YYYY")}
              </small>
            </div>
          </div>

          {blog.cover_images ? (
            <div className="text-center py-3">
              <img
                src={blog.cover_images.length > 0 && blog.cover_images[0]}
                alt="cover image"
                height="400px"
              />
            </div>
          ) : (
            <div className="text-center">
              <Spinner size="lg" />
            </div>
          )}
          <div
            style={{ width: "100%", maxWidth: "580px" }}
            className="text-center mt-3 mx-auto"
          >
            <p className="text-left">
              <div
                dangerouslySetInnerHTML={{
                  __html: blog.desc,
                }}
              ></div>
            </p>
          </div>
          <p className="footer__heading text-center mt-5">
            {blogs.length > 1 && "Similar articles"}
          </p>
          <Row className="mt-4">
            {blogs.length > 0 &&
              blogs
                .filter((blog, index) => blog.id != props.match.params.id)
                .slice(0, 4)
                .map((blog, idx) => (
                  <Link to={`/main/blog/${blog.id}`}>
                    <Col
                      md="6"
                      lg="4"
                      xl="3"
                      className="text-left mb-5"
                      onClick={() => {
                        window.scrollTo(0, 0);
                      }}
                    >
                      <img
                        src={
                          blog.cover_images.length > 0 && blog.cover_images[0]
                        }
                        className="w-100 mb-4"
                      />
                      <small className="text-muted">
                        {moment
                          .unix(blog.created_at.seconds)
                          .format("DD MMMM YYYY")}
                      </small>
                      <h5
                        className="text-uppercase"
                        style={{
                          fontFamily: "Ogg",
                          letterSpacing: 6,
                        }}
                      >
                        {blog.title}
                      </h5>
                      <p className="mt-4">
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              blog.desc.length > 100
                                ? blog.desc.substr(0, 100) + "......"
                                : blog.desc,
                          }}
                        ></div>
                      </p>
                    </Col>
                  </Link>
                ))}
          </Row>
        </Container>
      ) : (
        <div className="center__loader">
          <Spinner size="lg" />
        </div>
      )}
    </>
  );
}

export default BlogDetails;
